import {forwardRef, ReactNode, useEffect} from 'react';
import clsx from 'clsx';

export type ModalContentProps = {
    children: ReactNode;
    className?: string;
    onCheckButtons?: () => void;
};

const ModalContent = forwardRef<HTMLDivElement, ModalContentProps>(
    ({children, className, onCheckButtons}, ref) => {
        const styleWidth =
            className && className.includes('w-') ? null : 'w-[37.5rem]'; // 25rem is "small"

        useEffect(() => {
            onCheckButtons?.();
        }, [onCheckButtons]);

        return (
            <div
                ref={ref}
                className={clsx(
                    styleWidth,
                    'elevation-400 m-auto rounded border border-grey-300 bg-grey-10',
                    className,
                )}
                data-modal-safe={true}
                role="dialog"
            >
                {children}
            </div>
        );
    },
);

ModalContent.displayName = 'ModalContent';

export default ModalContent;
